import React from 'react';
import styles from "./Image.module.scss"
import profile from 'assets/img/profile.png';

function ImageMessage (props) {
    const {
        width,
        height,
        className,
        src,
        defaultImage,
        style,
        seo = "",
        srcset,
        sizes,
    } = props;
    const onError = (e) => {
        e.target.onerror = null;
        e.target.src = defaultImage;
    };
    const onClick = () => {
        if (typeof props.onClick === 'function') {
            props.onClick();
        }
    };
    return <img
        width={width}
        height={height}
        style={style}
        className={`${styles.object_fit_cover} ${className ?? ''}`}
        src={src ?? defaultImage}
        onError={onError}
        onClick={onClick}
        alt={seo}
        title={seo}
        srcSet={srcset?.toString()}
        size={sizes}
    />;
}
ImageMessage.defaultProps = {
    defaultImage: profile,
    srcset: [],
    sizes: '',
};
export default ImageMessage;
